<template>
  <div class="container bg-white">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('privacy.penggunaanInformasi.title') }}</h3>
        <div class="divider"></div>
        <p>{{ $t('privacy.penggunaanInformasi.line1') }}</p>
        <p>{{ $t('privacy.penggunaanInformasi.line2') }}</p>
        <p>{{ $t('privacy.penggunaanInformasi.line3') }}</p>
        <p>{{ $t('privacy.penggunaanInformasi.line4') }}</p>
        <p>{{ $t('privacy.penggunaanInformasi.line5') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'penggunaan-informasi',
};
</script>
